export default "__VITE_ASSET__06En$5wo__"